/**
 * IncompleteEmptyState — shown when the Incomplete bucket has zero draft orders.
 *
 * Three-part: icon + title + reassuring body. No call-to-action button.
 * Reuses the same visual style as OrdersEmptyState (dashed border, envelope icon area).
 */

import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";

function CheckCircleIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
      <polyline points="22 4 12 14.01 9 11.01" />
    </svg>
  );
}

export function IncompleteEmptyState() {
  const t = useTranslations();
  return (
    <div className="flex flex-col items-center gap-3 rounded-[14px] border border-dashed border-[#d4cfc5] bg-[#faf8f2] px-6 py-20 text-center">
      <span
        aria-hidden="true"
        className="flex h-14 w-14 items-center justify-center rounded-[14px] bg-[#f0ece4] text-[#a59f90]"
      >
        <CheckCircleIcon />
      </span>
      <div className="text-[15px] font-semibold text-[color:var(--text-primary)]">
        {t(keys.orders.incompleteEmptyTitle)}
      </div>
      <div className="text-[13px] text-[color:var(--text-muted)]">
        {t(keys.orders.incompleteEmptyBody)}
      </div>
    </div>
  );
}
